import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "forecast-accuracy" }
const _hoisted_2 = { class: "forecast-accuracy__top-area top-area" }
const _hoisted_3 = { class: "forecast-accuracy__filter-content filter-content" }
const _hoisted_4 = { class: "forecast-accuracy__table-area table-area" }
const _hoisted_5 = { class: "table-area__top-accessory" }
const _hoisted_6 = { class: "table-area__select-month-area select-month-area" }
const _hoisted_7 = { class: "select-month-area__title" }
const _hoisted_8 = {
  key: 0,
  class: "table-area__business-table table-area__business-table--zero-match"
}

import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import ControlCustomerPageTab from '../components/ControlCustomerPageTab.vue';
import { CUSTOMER_TAB_ROUTER_INFO } from '../constants';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import SelectInput from '@/corePagesModule/SelectInput';
import { i18n } from '@/i18n';
import MultipleUserSelectInput from '@/corePagesModule/user/SelectInput/MultipleUserSelectInput.vue';
import { useForecastAccuracyStore } from './useForecastAccuracyStore';
import DownloadAccuracyRateModal from '../components/DownloadAccuracyRateModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastAccuracy',
  setup(__props) {

const t = i18n.t;
const locale = computed(() => i18n.locale);

// Use store
const store = useForecastAccuracyStore();
const { state, tableContentItems, monthsOptionsDisplayForecast, tableHeaders } = storeToRefs(store);

// Destructure store methods for easier access
const {
  onSelectedReceiveMonth,
  onChangePaging,
  onSelectedDisplayForecastsMonth,
  updateResponsibleUserFilter,
  onClickDownload,
  sortTableContentItems,
} = store;

// Initialize store on mount
onMounted(() => {
  store.init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ControlCustomerPageTab, {
        class: "top-area__tab-bar",
        "tab-info-object": [..._unref(CUSTOMER_TAB_ROUTER_INFO)]
      }, null, 8, ["tab-info-object"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(MultipleUserSelectInput, {
        class: "filter-content__select-responsible-user",
        "select-input-index": 31,
        label: '',
        "original-selected-user-id-list": _unref(state).selectedResponsibleUserIdList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (userIds) => _unref(updateResponsibleUserFilter)(userIds))
      }, null, 8, ["original-selected-user-id-list"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(locale.value === 'ja' ? '表示月' : 'Display Month'), 1),
          _createVNode(MonthPicker, {
            class: "select-month-area__calendar",
            "model-value": _unref(state).receivedForecastYearMonthInfo,
            locale: locale.value,
            "prop-format": _unref(t)('MonthPickerFormat'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(onSelectedReceiveMonth)($event)))
          }, null, 8, ["model-value", "locale", "prop-format"])
        ]),
        (_unref(state).tableContents.pagingOptions)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              "paging-options": _unref(state).tableContents.pagingOptions,
              "is-loading": _unref(state).tableContents.loadingState.status.type === 'loading',
              class: "table-area__pagination",
              onOnChangePage: _cache[2] || (_cache[2] = ($event: any) => (_unref(onChangePaging)($event)))
            }, null, 8, ["paging-options", "is-loading"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(SelectInput), {
          class: "table-area__forecast-length-select",
          index: 30,
          "model-value": _unref(t)('displayMonthsOfData', { month: _unref(state).displayForecastsMonth }),
          placeholder: '',
          label: '',
          "filter-type": 'DISPLAY_MONTH',
          "prop-options": _unref(monthsOptionsDisplayForecast),
          "is-open-prop": _unref(state).openedSelectInputType === 'DISPLAY_MONTH',
          "use-teleport": "",
          "onClick:selectInput": _cache[3] || (_cache[3] = () => (_unref(state).openedSelectInputType = 'DISPLAY_MONTH')),
          "onUpdate:valueWithIndex": _cache[4] || (_cache[4] = (_, index) => _unref(onSelectedDisplayForecastsMonth)(index))
        }, null, 8, ["model-value", "prop-options", "is-open-prop"])
      ]),
      (_unref(state).tableContents.loadingState.status.type === 'zeroMatch')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('forecastForReceipt_placeholderForZeroMatch')), 1))
        : (_openBlock(), _createBlock(NewBaseTableContent, {
            key: _unref(state).tableContents.renderingKey,
            class: "table-area__business-table table-area__business-table--success",
            "prop-table-content-properties": _unref(tableHeaders),
            "prop-display-objects": _unref(tableContentItems),
            "prop-loading-status": _unref(state).tableContents.loadingState,
            "prop-table-type": 'forecastAccuracyTable',
            onOnClickSort: _cache[5] || (_cache[5] = (sortKey) => _unref(sortTableContentItems)(sortKey)),
            onOnClickDownload: _cache[6] || (_cache[6] = (displayId) => _unref(onClickDownload)(displayId))
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
    ]),
    _createVNode(DownloadAccuracyRateModal, {
      store: _unref(store),
      "default-start-year-month": _unref(state).downloadModalState.startYearMonth,
      "default-end-year-month": _unref(state).downloadModalState.endYearMonth
    }, null, 8, ["store", "default-start-year-month", "default-end-year-month"])
  ]))
}
}

})